import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

import getFetchOptions from 'utils/getFetchOptions';

export default function rescoreTest(id, gender, grade, isForeign) {
	return fetch(
		`${ENDPOINT_URL}/dldtest/rescore/${id}`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify({
				gender,
				grade,
				isForeign,
			}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}

			return response.json();
		})
		.catch((err) => {
			Promise.reject(apiErrorHandling(err));
			return err.ok;
		});
}
